
export const Coin = () => {
    return (
        <svg aria-hidden width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5707_13096)">
                <rect width="32" height="32" fill="white" fillOpacity="0.01" />
                <rect width="32" height="32" rx="16" fill="#00807B" fillOpacity="0.12" />
                <g clipPath="url(#clip1_5707_13096)">
                    <path
                        d="M6 14.125C6 17.2305 10.4766 19.75 16 19.75C21.5234 19.75 26 17.2305 26 14.125C26 11.0195 21.5234 8.5 16 8.5C10.4766 8.5 6 11.0195 6 14.125ZM6 17.332V18.5C6 19.5898 6.69531 20.5938 7.875 21.4141V18.9297C7.16016 18.4805 6.51562 17.9453 6 17.332ZM9.125 22.1328C10.1836 22.6328 11.4609 23.0195 12.875 23.2539V20.7422C11.5039 20.5078 10.2344 20.1211 9.125 19.6094V22.1328ZM14.125 23.4141C14.7305 23.4727 15.3594 23.5 16 23.5C16.6406 23.5 17.2695 23.4687 17.875 23.4141V20.9102C17.2617 20.9727 16.6367 21.0039 16 21.0039C15.3633 21.0039 14.7383 20.9727 14.125 20.9102V23.4141ZM19.125 23.2539C20.5391 23.0195 21.8164 22.6328 22.875 22.1328V19.6055C21.7656 20.1211 20.4961 20.5039 19.125 20.7383V23.25V23.2539ZM24.125 21.418C25.3047 20.5977 26 19.5898 26 18.5039V17.3359C25.4844 17.9453 24.8398 18.4805 24.125 18.9336V21.4219V21.418Z"
                        fill="#00807B"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5707_13096">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
                <clipPath id="clip1_5707_13096">
                    <rect width="20" height="20" fill="white" transform="translate(6 6)" />
                </clipPath>
            </defs>
        </svg>
    );
};
